import _ from 'lodash';
import type { ReactNode } from 'react';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import PopOver from '../components/deprecated/PopOver';
import PopOverContainer from '../components/deprecated/PopOverContainer';
import UserDetailPreviewPopOver from '../user/UserDetailPreviewPopOver';
import userPath from '../utils/url/userPath';
import type { PresenceAvatarStatus } from './PresenceAvatar';
import PresenceAvatar from './PresenceAvatar';
import styles from './PresencePopOver.module.scss';
import type { PresenceStateUser } from '../editor/editorSlice';

interface PresenceUserRowProps {
  users: PresenceStateUser[];
  status: PresenceAvatarStatus;
}

const PresenceUserRow = ({ users, status }: PresenceUserRowProps) =>
  users.length > 0 ? (
    <>
      <h3 className={styles.title}>{_.capitalize(status)}</h3>
      {users.map((user) => (
        <UserDetailPreviewPopOver
          key={user.id}
          userId={user.id}
          placement="left"
        >
          <Link className={styles.userRow} to={userPath(user)}>
            <PresenceAvatar status={status} index={user.index} user={user} />
            {user.name}
          </Link>
        </UserDetailPreviewPopOver>
      ))}
    </>
  ) : null;

interface PresencePopOverProps {
  children: ReactNode;
  users: {
    user: PresenceStateUser;
    status: PresenceAvatarStatus;
  }[];
}

const PresencePopOver = ({ children, users }: PresencePopOverProps) => {
  const {
    editing = [],
    reading = [],
    inactive = [],
  } = _.groupBy(users, ({ status }) => status);

  return (
    // @ts-expect-error
    <PopOver
      placement="bottom"
      popOver={
        <PopOverContainer width="auto" noPadding>
          <div className={styles.container}>
            <PresenceUserRow
              status="editing"
              users={editing.map(({ user }) => user)}
            />
            {editing.length > 0 && reading.length > 0 && (
              <div className={styles.separator} />
            )}
            <PresenceUserRow
              status="reading"
              users={reading.map(({ user }) => user)}
            />
            {(editing.length > 0 || reading.length > 0) &&
              inactive.length > 0 && <div className={styles.separator} />}
            <PresenceUserRow
              status="inactive"
              users={inactive.map(({ user }) => user)}
            />
          </div>
        </PopOverContainer>
      }
      responsivePlacement="bottom"
      trigger="hover"
    >
      {children}
    </PopOver>
  );
};

export default PresencePopOver;
